import { render, staticRenderFns } from "./BookList_phone.vue?vue&type=template&id=d2840d52&scoped=true"
import script from "./BookList_phone.vue?vue&type=script&lang=js"
export * from "./BookList_phone.vue?vue&type=script&lang=js"
import style0 from "./BookList_phone.vue?vue&type=style&index=0&id=d2840d52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2840d52",
  null
  
)

export default component.exports